<div class="page-card">
    <div class="page-card-header">
        <h1><ng-content select="[textHeader]"></ng-content></h1>
        <ng-content select="[middleSectionHeader]"></ng-content>
        <div class="action-buttons-container">
            <div class="actions">
                <ng-content select="[actionsHeader]"></ng-content>
            </div>
            @if (!hideCloseBtn) {
                <p-button
                    id="close-main-page-btn"
                    [text]="true"
                    [rounded]="true"
                    severity="secondary"
                    class="exit-button"
                    [ariaLabel]="'Close Page'"
                    [disabled]="isCloseButtonDisabled"
                    [class.disabled-element]="isCloseButtonDisabled"
                    (onClick)="exit.emit()">
                    <i class="fa-sharp fa-regular fa-xmark"></i>
                </p-button>
            }
        </div>
    </div>
    <div class="page-card-body">
        <ng-content select="[body]"></ng-content>
    </div>
</div>
